export enum UsuarioFuncao {
  SUPERVISOR = 50,
  GESTOR = 40,
  CORRETOR = 30,
  ANALISTA = 20,
  ADMINISTRADOR = 10,
  SUPORTE = 1,
}